import { DateRangeType } from "@shared/enums/date-range-type.enum";

export class DateRange {
  public range: DateRangeType | null;
  public startFrom: string | null;
  public endAt: string | null;
}
